module.exports = __webpack_public_path__ + "static/media/scegli il corso 2.20db808e.png";